import { ClientConfig, createClient as prismicCreateClient } from '@prismicio/client'

export const createClient = (config: ClientConfig = {}) => {
  return prismicCreateClient('interactive-media-design-day', {
    ...config,
  })
}

import {
  FooterDocument,
  NavigationDocument,
  PageDocument,
  PastSpeakerDocument,
  SettingsDocument,
  SpeakerDocument,
  TimetableDocument,
} from '../types/types.generated'

export async function getData(ref?: string): Promise<{
  pages: PageDocument[]
  speakers: SpeakerDocument[]
  pastSpeakers: PastSpeakerDocument[]
  footer: FooterDocument
  navigation: NavigationDocument
  timetable: TimetableDocument
  settings: SettingsDocument
}> {
  const client = createClient({ ref })

  const [pages, speakers, pastSpeakers, footer, navigation, timetable, settings] = await Promise.all([
    client.getAllByType('page', { ref }),
    client.getAllByType<SpeakerDocument>('speaker', { ref }),
    client.getAllByType<PastSpeakerDocument>('past_speaker', { ref }),
    client.getSingle<FooterDocument>('footer', { ref }),
    client.getSingle<NavigationDocument>('navigation', { ref }),
    client.getSingle<TimetableDocument>('timetable', { ref }),
    client.getSingle<SettingsDocument>('settings', { ref }),
  ])

  return {
    pages,
    speakers,
    pastSpeakers,
    footer,
    navigation,
    timetable,
    settings,
  }
}
